import React from "react";
import styled from 'styled-components';

const ChatWrapper = styled.div`
position: fixed;
bottom: 40px;
z-index: 202;
display: flex;
flex-direction: column;
align-items: end;
gap: 15px;
max-width: 350px;
&.left {
    align-items: start;
    left: 40px;
}
&.right {
    align-items: end;
    right: 40px;
}
&.fullscreen {
    z-index: 300;
}
`;

export default ChatWrapper;